import React from "react"
import PropTypes from "prop-types"

import useSiteMetadata from "../hooks/use-site-metadata"

const fixMetaImageURL = url => {
  if (url && url.startsWith("https://images.ctfassets.net/")) {
    const [urlWithoutParams] = url.split("?")
    return `${urlWithoutParams}?w=1200&h=630&q=50&fm=jpg`
  }

  return url
}

const openGraphMetaTags = (title, description, image, url) => (
  <>
    <meta name="og:type" content="website" />
    <meta name="og:title" content={title} />
    <meta name="og:description" content={description} />
    <meta name="og:image" content={image} />
    <meta name="og:url" content={url} />
  </>
)

const twitterMetaTags = (
  title,
  description,
  image,
  cardType,
  author,
  readingTime,
  url
) => (
  <>
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />
    <meta name="twitter:card" content={cardType || "summary"} />
    <meta name="twitter:creator" content={author} />
    <meta name="twitter:url" content={url} />
    {readingTime && <meta name="twitter:label1" content="Reading time" />}
    {readingTime && <meta name="twitter:data1" content={readingTime} />}
  </>
)

const cookieBotScript = () => (
  <script
    id="CookieDeclaration"
    src={`https://consent.cookiebot.com/${process.env.COOKIEBOT_ID}/cd.js`}
    type="text/javascript"
  ></script>
)

function SEO({
  description,
  title,
  searchIndexing,
  metaImage,
  metaTwitterCardType,
  readingTime,
  pathname,
}) {
  const {
    title: defaultTitle,
    description: defaultDescription,
    author,
    image,
    siteUrl,
  } = useSiteMetadata()
  const metaDescription = description || defaultDescription
  const metaImg = fixMetaImageURL(metaImage || image)
  const metaTitle = title || defaultTitle
  const url = `${siteUrl}${pathname}`

  return (
    <>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      {openGraphMetaTags(metaTitle, metaDescription, metaImg, url)}
      {twitterMetaTags(
        metaTitle,
        metaDescription,
        metaImg,
        metaTwitterCardType,
        author,
        readingTime,
        url
      )}
      {searchIndexing === false && <meta name="robots" content="noindex" />}
      {cookieBotScript()}
    </>
  )
}

SEO.defaultProps = {
  searchIndexing: true,
  description: ``,
  metaImage: null,
  metaTwitterCardType: "summary",
  readingTime: undefined,
}

SEO.propTypes = {
  description: PropTypes.string,
  metaImage: PropTypes.string,
  metaTwitterCardType: PropTypes.string,
  title: PropTypes.string,
  searchIndexing: PropTypes.bool,
  readingTime: PropTypes.string,
  pathname: PropTypes.string,
}

export default SEO
